import { IWizardCol } from './../../wizard/wizard-col.component';
import { WizardService } from './../../wizard/wizard.service';

export const step0: IWizardCol = {
  title: 'sessions.create.wizard.step1_1_private.title',
  subscription: new WizardService().getAccountTypeSubscription(),
  cols: [
    {
      title: 'sessions.create.wizard.step1_1_public.free',
      description: ['sessions.create.wizard.step1_1_public.free_description'],
      icon: 'unlock',
      option: 'free'
    },
    {
      title: 'sessions.create.wizard.step1_1_public.registration',
      description: [
        'sessions.create.wizard.step1_1_public.registration_description',
        'sessions.create.wizard.step1_1_public.social_description'
      ],
      icon: 'lock',
      option: 'registration'
    },
    {
      title: 'sessions.create.wizard.step1_1_private.invitation',
      description: ['sessions.create.wizard.step1_1_private.invitation_description'],
      icon: 'envelope-open',
      option: 'invitation'
    },
    {
      title: 'sessions.create.wizard.step1_1_private.generic_login',
      description: ['sessions.create.wizard.step1_1_private.generic_login_description'],
      icon: 'users',
      option: 'generic_login'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/step0.ts